<script setup>
import { useEventStore } from '@stores/event'
import Loading from '@sections/global/Loading.vue'
import FeaturedEvents from '@sections/index/FeaturedEvents.vue'
import Events from '@sections/index/Events.vue'

const store = useEventStore()
</script>

<template>
	<Loading v-if="!store.events.length" />
	<template v-else>
		<FeaturedEvents />
		<Events />
	</template>
</template>
